import { createAction, createReducer } from 'deox';
import { resetApplication } from './resetApplication';

// attempts: number - number of OTP attempts made - default 0
// expireTime?: number - (probably in UNIX time (ms)) - default null
// otpCode?: string - the successful OTP code - default null

// State

export const EXPIRE_TIME = 15 * 60; // 15 minutes (in seconds)

export interface OtpCode {
  attempts: number;
  expireTime: number | null;
  otpCode: string | null;
}

export const defaultState: OtpCode = {
  attempts: 0,
  expireTime: null,
  otpCode: null,
};

// Actions

export const incrementAttempts = createAction('INCREMENT_ATTEMPTS');

export const setExpireTime = createAction('SET_EXPIRE_TIME');

export const setOtpCode = createAction(
  'SET_OTP_CODE',
  resolve => (otpCode: string) => resolve({ otpCode }),
);

// Reducer

export const otpCodeReducer = createReducer(defaultState, handleAction => [
  handleAction(incrementAttempts, state => ({
    ...state,
    attempts: state.attempts + 1,
  })),
  handleAction(setExpireTime, state => ({
    ...state,
    attempts: 0,
    expireTime: Date.now() + EXPIRE_TIME * 1000, // UNIX timestamp in ms
  })),
  handleAction(setOtpCode, (state, { payload: { otpCode } }) => ({
    ...state,
    otpCode,
  })),
  handleAction(resetApplication, () => defaultState),
]);

// Selectors

export interface MountedState {
  otpCode: OtpCode;
}

export const selectAttempts = (state: MountedState): number =>
  state.otpCode.attempts;

export const selectExpireTime = (state: MountedState): number | null =>
  state.otpCode.expireTime;

export const selectOtpCode = (state: MountedState): string | null =>
  state.otpCode.otpCode;

export default otpCodeReducer;
